import { useEffect, useState } from "react";
import { msalConfiguration } from "../../../../../assets/auth/msalConfig";
import { PublicClientApplication } from "@azure/msal-browser";
// TODO: Remove the dependency when we decide on the new tracking solution
import trackerHelper from "@coworker/app/src/helpers/tracker";

import "@ingka-group-digital/cwep-hej-bygglek-webc";
import {
  initHejComponent,
  HejEventsHandler,
} from "@ingka-group-digital/cwep-hej-core";
import {
  HejPublishedWebc,
  HejPublishedEvents,
} from "@ingka-group-digital/cwep-hej-types";
import { pickTranslationFile } from "./translations/pickTranslationFile";

import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import SquareGrid3x3FilledIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/SquareGrid3x3FilledIconPath";

import style from "./hej-app-switcher.module.css";
import { useTranslation } from "@coworker/locales";

// This event is to handle updating of the state when the app switcher is closed
// As the initHejComponent cannot be called inside of a component,
// we need to use this event to update the state via the window object event
const hejAppSwitcherClosedEvent = new Event("hejAppSwitcherClosed");

initHejComponent({
  name: "Fixa",
  msalConfig: msalConfiguration,
  events: {
    emit: (
      component: HejPublishedWebc,
      eventName: HejPublishedEvents,
      ...params: any[]
    ) => {
      if (component === "hej-appswitcher-webc") {
        trackerHelper.trackHejComponentEvent(eventName, params);
      }

      if (
        component === "hej-appswitcher-webc" &&
        eventName === "AppSwitcherClosed"
      ) {
        window.dispatchEvent(hejAppSwitcherClosedEvent);
      }
    },
  } as HejEventsHandler,
  apiScopeList: ["favorite", "link", "user"],
  logOutHandler: () => {
    const pca = new PublicClientApplication({
      auth: { clientId: msalConfiguration.auth.clientId },
    });
    pca.initialize().then(() => {
      pca.logoutRedirect();
    });
  },
  translationProvider: pickTranslationFile(),
});

const HejAppSwitcher = () => {
  const [opened, setOpened] = useState(false);
  const { t } = useTranslation();
  const toggleOpened = () => {
    setOpened(!opened);
    trackerHelper.trackHejComponentSquareGridIconClick();
  };

  useEffect(() => {
    const handleHejAppSwitcherClosed = () => {
      setOpened(false);
    };

    window.addEventListener("hejAppSwitcherClosed", handleHejAppSwitcherClosed);

    return () => {
      window.removeEventListener(
        "hejAppSwitcherClosed",
        handleHejAppSwitcherClosed
      );
    };
  }, []);
  // @ts-expect-error - Created ticket about it: COAPP-11453
  const AppSwitcher = <hej-appswitcher-webc></hej-appswitcher-webc>;
  return (
    <div className={style["hej-app-switcher"]}>
      <FixaButton
        data-testid="hejAppSwitcher"
        aria-label={t("appSwitcherString")}
        ssrIcon={SquareGrid3x3FilledIconPath}
        onClick={toggleOpened}
        iconOnly
        inverseTheme
        type="tertiary"
      />
      {opened && AppSwitcher}
    </div>
  );
};

export default HejAppSwitcher;
